import { newSecretManagerElement } from "@p0security/integrations-vaulted-credential-shared";
import {
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

const allSecretManagers = newSecretManagerElement({
  owner: "Cloudflare account",
  connector: "Cloudflare",
});

const secretManager = Element({
  ...allSecretManagers,
  default: "gcp-sm",
});

// The connector's IAM condition matches the id up to the next `_` in each GCP
// secret name, where `/` becomes `_` and `.` becomes `-`. A grant token's name
// holds its secret's name, and Cloudflare caps token names at 120 characters,
// so the id is at most 64.
const ITEM_ID_PATTERN = /^[A-Za-z0-9-]{1,64}$/;

const ACCOUNT_ID_PATTERN = /^[0-9a-f]{32}$/;

export const CloudflareAiComponents = InstallSpec({
  credential: ItemComponent({
    label: "Credential provisioning",
    description: "Allow P0 to grant machines access to Cloudflare",
    type: "string",
    maturity: "beta",
    validator: async (_context: unknown, id: string) =>
      ITEM_ID_PATTERN.test(id)
        ? undefined
        : "Use only letters, digits and hyphens, up to 64 characters",
    schema: {
      accountId: Element({
        label: "Account ID",
        description:
          "The 32-character ID of the Cloudflare account, from the account's home page in the Cloudflare dashboard",
        type: "string",
        step: "new",
        validator: async (_context: unknown, accountId: string) =>
          ACCOUNT_ID_PATTERN.test(accountId)
            ? undefined
            : "Use the 32 lowercase hexadecimal characters of the account ID",
      }),
      secretManager,
      // P0 reads this from the connector each time it verifies the item:
      // the names of the install token's groups beyond the two it needs,
      // joined by ", ".
      otherGroups: Element({
        label: "Other permission groups",
        description:
          "The install token's permission groups beyond Account API Tokens Edit and Zone Read, read when an admin last checked the account",
        type: "generated",
      }),
    },
  }),
});
